import { createAction, ActionType } from 'typesafe-actions';

export const onNestedView = createAction('ON_NESTED_VIEW', (route: string) => route)();
export const offNestedView = createAction('OFF_NESTED_VIEW', () => {})();

export type NestedViewActions = ActionType<typeof onNestedView | typeof offNestedView>;
